export class ListFindingsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "findings",
            "baseName": "findings",
            "type": "Array<FindingEntry>",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListFindingsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
